module.exports = __webpack_public_path__ + "img/button-home3.f4be83f2.png";